import { render, staticRenderFns } from "./PostTagList.vue?vue&type=template&id=65836bfc&"
import script from "./PostTagList.vue?vue&type=script&lang=js&"
export * from "./PostTagList.vue?vue&type=script&lang=js&"
import style0 from "./PostTagList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PostTagList.vue"
export default component.exports